module.exports = __webpack_public_path__ + "img/shortcuts.dabca1e6.jpeg";